import { Col, Divider, Row, Table } from "antd";
import { UNITS } from "../../Common/Constants";
import RED_BADGE from "../../../assets/images/redBadge.svg";
import GREEN_BADGE from "../../../assets/images/greenBadge.svg";

const RunningVehicles = ({ title, totalKm, vehicleList }) => {
  const columns = [
    {
      title: "IMEI",
      dataIndex: "imei",
      key: "imei",
      className: "grey imei-text bold",
    },
    {
      title: "Distance",
      dataIndex: "distance",
      key: "distance",
      align: "center",
      render: (distance) => (
        <div className="justify-center" data-testid="running-distance">
          <span
            className={
              "distance bold mr025" + (title === "Top" ? " green" : " orange")
            }
          >
            {distance}
          </span>
          <span className="unit mt01 grey">{UNITS.KM}</span>
        </div>
      ),
    },
  ];

  return (
    <Row className="shadow-card mt1 p0">
      <Col span={24}>
        <div className="running-title flex-center">
          <img src={title === "Top" ? GREEN_BADGE : RED_BADGE} alt="Top" className="mr05" /> 
          {title} Running
        </div>
      </Col>

      <Col span={24} className="running-title-line">
        <Divider className="md0" />
      </Col>

      <Col span={24} className="text-center border-bottom">
        <div className="flex-center pd1 h100">
          <div className="card-value">{totalKm}</div>
          <div className="unit align-end h100 ml025 mb1">{UNITS.KM}</div>
        </div>
      </Col>

      <Col span={24} className="pd1 table-title">
        {title === "Top" ? "Top 10" : "Least"} Running Vehicles
      </Col>
      <Col span={24} className="plr1">
        <Table columns={columns} dataSource={vehicleList} pagination={false} rowKey={(record) => record.imei} />
      </Col>
    </Row>
  );
};

export default RunningVehicles;
